var audio_rtlignore_default = {
  "fontElementMap": "S26ow",
  "container": "e8k7q",
  "customPlayer": "yzHL5",
  "slim": "L8VOm",
  "playPauseButton": "mdfoU",
  "coverImage": "Gn6qB",
  "trackDetailsContainer": "-OK4v",
  "controlsContainer": "muO0D",
  "controlsGroup": "WMcoN",
  "sliderContainer": "_3CkJ1",
  "audioDuration": "_2mJi0",
  "isLoading": "rRCvw",
  "audioIconButton": "_-3yi4",
  "audioVolumeWrapper": "b9qak",
  "volumeSliderWrapper": "Lyl12",
  "audioDetails": "_5Nyct",
  "authorName": "q9M6d",
  "title": "oXr0D",
  "audioContextMenuWrapper": "PWddh",
  "dropdownMenuWrapper": "CurNc",
  "dropdownSelectedButton": "zy7iE",
  "dropdownContent": "_8caK8",
  "dropdownContentWithIcon": "auc9d",
  "audioLoader": "bJRpx"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
